import { JhiAlertService, JhiEventManager } from 'ng-jhipster';
import { ALERTS_CHANGED } from '../constants/subscription.constants';

export class AlertUtils {
    private static OK = 'OK';
    private static ERROR = 'Error';
    private static INFO = 'Info';
    private static WARNING = 'Warning';

    public static notifySuccess(eventManager: JhiEventManager, alertService: JhiAlertService, message: string, params?: any) {
        if (alertService == null || eventManager == null) {
            return;
        }

        alertService.success(message, params, null);
        eventManager.broadcast({ name: ALERTS_CHANGED, content: AlertUtils.OK });
    }

    public static notifyError(eventManager: JhiEventManager, alertService: JhiAlertService, message: string, params?: any) {
        if (alertService == null || eventManager == null) {
            return;
        }

        alertService.error(message, params, null);
        eventManager.broadcast({ name: ALERTS_CHANGED, content: AlertUtils.ERROR });
    }

    public static notifyInfo(eventManager: JhiEventManager, alertService: JhiAlertService, message: string, params?: any) {
        if (alertService == null || eventManager == null) {
            return;
        }

        alertService.info(message, params, null);
        eventManager.broadcast({ name: ALERTS_CHANGED, content: AlertUtils.INFO });
    }

    public static notifyWarning(eventManager: JhiEventManager, alertService: JhiAlertService, message: string, params?: any) {
        if (alertService == null || eventManager == null) {
            return;
        }

        alertService.warning(message, params, null);
        eventManager.broadcast({ name: ALERTS_CHANGED, content: AlertUtils.WARNING });
    }

    public static notifyNotFound(eventManager: JhiEventManager, alertService: JhiAlertService) {
        AlertUtils.notifyError(eventManager, alertService, 'error.notFound');
    }

    public static notifyAccessDenied(eventManager: JhiEventManager, alertService: JhiAlertService) {
        AlertUtils.notifyError(eventManager, alertService, 'error.accessDenied');
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/utils/alert-utils.ts